module.exports = __webpack_public_path__ + "img/box_bg2.5258c8d4.png";